import { render } from "./indexsixtestimonial.vue?vue&type=template&id=15b4e268"
import script from "./indexsixtestimonial.vue?vue&type=script&lang=js"
export * from "./indexsixtestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__